import validate from 'validate.js';
import { parsePhoneNumberFromString as parseMin } from 'libphonenumber-js/max'
import popupMessage from "./popup-message";

export default function (form, requiredFields) {

    validate.validators.telCheck = function(value, options, key, attributes) {

        if (value) {
            let phoneNumber = parseMin(value, 'PL');

            if (phoneNumber.isValid()) {
                return;
            } else {
                return 'Podaj poprawny numer';
            }
        }
    };

    const inputs = form.querySelectorAll("input, textarea, select");

    inputs.forEach((input)=>{
        if(input.type === 'checkbox') {
            input.addEventListener('click',()=>{
                input.closest('.form-row').classList.remove('has-error');
            })
        } else {
            input.addEventListener('focus', () => {
                input.closest('.form-row').classList.remove('has-error');
            })
        }
        input.closest('.form-row').querySelector('.form-row__error').innerText = '';
    });

    function sendForm(form) {
        return new Promise(function(resolve, reject) {
            const formData = new FormData(form);
            let request = new XMLHttpRequest();
            const method = form.getAttribute("method");
            const action = form.getAttribute("action")
            request.open(method, action);
            // request.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
            request.send(formData);

            request.onload = function () {
                if (request.status == 200) {
                    let response = JSON.parse(request.response);
                    resolve(response);
                    popupMessage(response.message);
                } else {
                    console.error(request.response)
                    reject(request.response);
                    popupMessage('Błąd podczas wysyłania formularza. Spróbuj ponownie później.', 'error');
                }
      }
        });
    }

    function showErrors(form, errors) {
        // console.log(inputs)
        inputs.forEach((input)=> {
            if(errors[input.name]) {
                let className = ".form-row";

                input.closest(className).classList.add('has-error');
                input.closest(className).querySelector(className + '__error').innerText = errors[input.name][0];
            }
        });

        if(grecaptcha) {
            if(grecaptcha.getResponse() === '') {
                form.querySelector('.g-recaptcha').closest('.form-row').classList.add('has-error');
                form.querySelector('.g-recaptcha').closest('.form-row').querySelector('.form-row__error').innerText = 'Zaznacz captcha';
            } else {
                form.querySelector('.g-recaptcha').closest('.form-row').classList.remove('has-error');
                form.querySelector('.g-recaptcha').closest('.form-row').querySelector('.form-row__error').innerText = '';
            }
        }

    }

    const promise = new Promise(function (resolve, reject) {
        form.addEventListener('submit', function(e){
            const errors = validate(form, requiredFields, { fullMessages: false });
            showErrors(form, errors || {});

            if (!errors) {
                if(grecaptcha && grecaptcha.getResponse() === '') {
                    form.querySelector('.g-recaptcha').closest('.form-row').classList.add('has-error');
                    form.querySelector('.g-recaptcha').closest('.form-row').querySelector('.form-row__error').innerText = 'Zaznacz captcha';
                    e.preventDefault();
                    return;
                }

                form.querySelector('button[type="submit"]').classList.add('is-loading');
                form.closest('.c-contactform').classList.add('is-loading');
                sendForm(form).then(function(response){
                    resolve(response);

                    inputs.forEach((input) => {

                        if(input.type === 'checkbox') input.checked = false;
                        else input.value = '';

                    });

                    if(grecaptcha) {
                        grecaptcha.reset();
                        form.querySelector('.g-recaptcha').closest('.form-row').classList.remove('has-error');
                    }

                }).catch(function(error){
                    alert('Błąd podczas wysyłania formularza. Spróbuj ponownie później.');
                    reject(error);
                }).finally(function(){
                    form.querySelector('button[type="submit"]').classList.remove('is-loading');
                    form.closest('.c-contactform').classList.remove('is-loading');

                    if(grecaptcha) {
                        grecaptcha.reset();
                        form.querySelector('.g-recaptcha').closest('.form-row').classList.remove('has-error');
                    }
                });
            }
            e.preventDefault();
        });
    });


    return promise;
}
